import { Controller } from "stimulus"

export default class extends Controller {
  // This is true for simple messages, if we want to have a more accurate limit please see link.
  // https://www.twilio.com/docs/glossary/what-sms-character-limit
  MAX_CHARACTERS_PER_SMS = 160

  CountCharacters() {
    this.bodyTextCounter.textContent = this.smsBodyTextArea.textLength
    if (this.smsBodyTextArea.textLength > 0) {
      this.determineNumberOfSms()
      this.bodyTextMaxCounter.textContent = this.MAX_CHARACTERS_PER_SMS * this.numberOfSmsCounter.textContent
    } else {
      this.numberOfSmsCounter.textContent = 1
      this.bodyTextMaxCounter.textContent = this.MAX_CHARACTERS_PER_SMS
    }
  }

  determineNumberOfSms() {
    this.remainder = this.bodyTextCounter.textContent % this.MAX_CHARACTERS_PER_SMS == 0 ? 0 : 1
    this.numberOfSmsCounter.textContent = parseInt(this.bodyTextCounter.textContent / this.MAX_CHARACTERS_PER_SMS) + this.remainder
  }

  get smsBodyTextArea() {
    return $('sms_body_text_area')
  }

  get bodyTextCounter() {
    return $('body_text_counter')
  }

  get bodyTextMaxCounter() {
    return $('body_text_max_counter')
  }

  get numberOfSmsCounter() {
    return $('number_of_sms_counter')
  }

}